module.exports = __webpack_public_path__ + "media/da_dk_s3_Ingrid.c64449ca.mp3";